export const defaultPageSize = 10;
export const SET_LAYOUT_TITLE = "SET_LAYOUT_TITLE";
export const UPDATE_NOTIFICATION_COUNT = "UPDATE_NOTIFICATION_COUNT";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const UPDATE_SIDEBAR_TAB = "UPDATE_SIDEBAR_TAB";
export const COUNTER_ACTION = "COUNTER_ACTION";
